'use client';

import SweepLight from '@/assets/svg/sweep-light.svg';

const ROW_COUNT = 3;

function StoryCardRowSkeleton() {
    return (
        <article className='relative flex w-[224px] shrink-0 items-center gap-[8px] overflow-hidden'>
            {/* 封面占位 */}
            <div className='h-[80px] w-[60px] shrink-0 animate-pulse rounded-[6px] bg-[#EBE9EE]' />
            <div className='min-w-0'>
                {/* 标题条 */}
                <div className='h-[14px] w-[136px] max-w-full animate-pulse rounded-[4px] bg-[#EBE9EE]' />
                {/* 标题条 */}
                <div className='mt-[6px] h-[14px] w-[112px] max-w-full animate-pulse rounded-[4px] bg-[#EBE9EE]' />
                {/* 标签条 */}
                <div className='mt-[16px] h-[12px] w-[73px] animate-pulse rounded-[4px] bg-[#EBE9EE]' />
            </div>
            {/* 扫光动画见 src/styles/animate.scss */}
            <span className='animate-skeleton-sweep-x pointer-events-none absolute left-0 top-[-10px] block h-[152px] w-[99px] shrink-0'>
                <SweepLight className='size-full' />
            </span>
        </article>
    );
}

export default function StoryCardSkeleton() {
    return (
        <div className='mt-[12px] w-full space-y-[12px] overflow-hidden'>
            <div className='flex w-[600px] gap-[12px]'>
                <div className='inline-block w-[224px] space-y-[12px]'>
                    {Array.from({ length: ROW_COUNT }, (_row, rowIndex) => (
                        <StoryCardRowSkeleton key={rowIndex} />
                    ))}
                </div>
                <div className='inline-block w-[224px] space-y-[12px]'>
                    {Array.from({ length: ROW_COUNT }, (_row, rowIndex) => (
                        <StoryCardRowSkeleton key={rowIndex} />
                    ))}
                </div>
            </div>
        </div>
    );
}
